import styled from '@emotion/styled';
import { Stack } from '@ui-components/neo.tax';

export const CenteredStack = styled(Stack)({
  padding: 2,
  justifyContent: 'center',
  width: '100%',
});
